import { render } from "./Footer.vue?vue&type=template&id=09da3f6f&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=09da3f6f&scoped=true&lang=css"

import exportComponent from "/Users/bobbarnard/Documents/sources/bungalow7-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09da3f6f"]])

export default __exports__